module.exports = __webpack_public_path__ + "static/media/color_logo_transparent.88c94a51.png";